module.exports = __webpack_public_path__ + "img/pic_suppay_rating_earncoins@3x.11c2e285.png";